import React from "react";

function VendasCardapio({ reportData, selectedMenu, cardapios }) {
  reportData.forEach((cardapio) => {
    cardapio.totais = cardapio?.vendas.reduce(
      (acc, produto) => {
        acc.total += produto.TOTAL ?? 0;
        acc.qtde += produto.QTDE ?? 0;
        acc.comissao += produto.COMISSAO ?? 0;

        return acc;
      },
      { total: 0, qtde: 0, comissao: 0 }
    );
  });

  return (
    <div className="flex box-border flex-col p-4 gap-12 justify-center items-center w-full">
      {reportData.map((cardapio) => (
        <div className="flex box-border flex-col rounded-lg shadow-lg mt-2 p-4 gap-4 justify-center items-center w-full">
          <div className="flex flex-col gap-4 justify-start w-full w-full text-center">
            <h2 className="font-Oswald ">
              {cardapio?.CODIGO
                ? cardapio?.CODIGO + " - " + cardapio?.DESCRICAO
                : "Sem Cardápio"}
            </h2>
          </div>

          <div className="box-border overflow-x-auto w-full">
            <table className="min-w-full bg-white border border-solid border-gray-300">
              <thead className="bg-gray-300">
                <tr>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] w-[50%]">
                    Produto
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Quantidade
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Comissão
                  </th>
                  <th className="font-Roboto px-4 py-2 border-b text-left text-sm font-[600] text-right w-[25%]">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {cardapio.vendas.map((row, index) => (
                  <tr
                    key={row?.DESCRICAO + index}
                    className="hover:bg-gray-200"
                  >
                    <td className="font-Roboto px-4 py-2 border-b text-sm">
                      {row.CODIGO} - {row.DESCRICAO}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {row.QTDE}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.COMISSAO).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                    <td className="font-Roboto px-4 py-2 border-b text-sm text-right">
                      {Number(row.TOTAL).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                ))}
                <tr className="bg-gray-300">
                  <td className="font-Roboto px-4 py-2 border-b text-sm font-[600]">
                    Total
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {cardapio.totais.qtde}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {" "}
                    {cardapio.totais?.comissao?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                  <td className="font-Roboto px-4 py-2 border-b text-sm text-right font-[600]">
                    {cardapio.totais?.total?.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ))}
    </div>
  );
}

export default VendasCardapio;
